import { render, staticRenderFns } from "./BindingTableItem.vue?vue&type=template&id=5dd2a64c&scoped=true"
import script from "./BindingTableItem.vue?vue&type=script&lang=js"
export * from "./BindingTableItem.vue?vue&type=script&lang=js"
import style0 from "./BindingTableItem.vue?vue&type=style&index=0&id=5dd2a64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2a64c",
  null
  
)

export default component.exports